import {
    $unAuthUser
} from '@/plugins/axios'
import {

} from "@/graphql/queries";
import {
    Auth
} from 'aws-amplify'

const state = {
    page: "account"
}

const getters = {

}

const actions = {

}

const mutations = {
    setPage(state, page) {
        state.page = page
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}